import { Link } from "@heroui/react";
import type { FC } from "react";
import type { IComponentBaseProps } from "@/shared/config";
import { useCN } from "@/shared/lib/hooks";
import { socialLinksMock } from "../api/mock";
import type { IFooter } from "../config";

/**
 * Компонент нижнего колонтитула (Footer) сайта Deepsum.
 * Содержит контакты, ссылки на социальные сети и вспомогательные ссылки.
 *
 * @component
 * @returns {ReactNode} Разметка подвала сайта
 */
export const Footer: FC<IFooter & IComponentBaseProps> = ({
  baseClass = "footer",
}) => {

  const { getCN } = useCN(baseClass);
  const { socials } = socialLinksMock;

  const links = [
    { link: "mailto:deepsumx@gmail.com", title: "Contact us" },
    { link: "/policy", title: "Terms of Service" },
    { link: "/policy", title: "Privacy Notice" },
  ];

  const fullYear = new Date().getFullYear();

  return (
    <footer className={getCN("", {}, [ "bg-codGray text-white-70" ])}>
      <div className={getCN("inner", {}, [ "container" ])}>
        <div className={"text-center tablet:py-30 mobile:py-12 py-12"}>
          <p className={"text mb-2 text-white"}>Contact us</p>
          <a
            href={"mailto:deepsumx@gmail.com"}
            className={"text-[10rem] tablet:text-[5rem] mobile:text-[3.5rem] font-bold isGradientText"}
          >
            deepsumx@gmail.com
          </a>
        </div>
        <hr className={"border-white-40"} />

        <div className={"flex mobile:mt-7 mobile:mb-11 mobile:flex-col mobile:gap-6 mobile:items-center mt-5 mb-10 justify-center"}>
          <p>Captain Works, Inc. © {fullYear}</p>
          {!!socials.length && <ul className={"flex items-center justify-center gap-6"}>
            {socials.map(({ name, src, href }, i) => (
              <li key={i}>
                <a
                  href={href}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                  aria-label={name}
                  className={"block w-7 h-7 transition-transform duration-300 hover:scale-110"}
                >
                  <img draggable={false} src={src} alt={name} className={"w-7 h-7 object-contain"} />
                </a>
              </li>
            ))}
          </ul>}
        </div>
        <div className={"mb-10"}>
          <div className={"flex flex-wrap justify-center gap-y-2 gap-x-2.5 text-center mobile:justify-start mobile:text-left"}>
            {links.map(({ link, title }, index) => (
              <Link
                key={index}
                href={link}
                className={`text-white-70 ${
                  index !== links.length - 1
                    ? "after:content-['•'] after:ml-2.5"
                    : ""
                }`}
              >
                {title}
              </Link>
            ))}
          </div>
        </div>
        {/* <div className={"grid grid-cols-1 mobile:grid-cols-2 tablet:grid-cols-4 gap-6 mb-8 "}>
          {linksQuestions.map((items, index) => (
            <ul key={index}>
              {items.map(({ link, title }, i) => (
                <li key={i}>
                  <Link href={link} className={"text-white-70 mb-2.5 block"}>
                    {title}
                  </Link>
                </li>
              ))}
            </ul>
          ))}
        </div> */}
      </div>
    </footer>
  );
};
